/**
 * Builds the { role, content }[] payload for chat agent endpoints from the
 * in-memory messages map (excluding reasoning placeholders).
 */
export const formatMessagesForChatAgent = (
  messages,
  userID,
  ephemeralUserTurn = null
) => {
  let messagesFormatted = Object.keys(messages)
    .map((key) => {
      const message = messages[key];
      const role = message.userID === userID ? "user" : "assistant";

      if (message.isReasoning) {
        return null;
      }
      const hasOptimizationsOrLearnings =
        (message.optimizations?.length ?? 0) > 0 ||
        (message.learnings?.length ?? 0) > 0;
      const assistantContent =
        role === "assistant" && hasOptimizationsOrLearnings
          ? JSON.stringify({
              answer: message.message,
              optimizations: message.optimizations || [],
              learnings: message.learnings || [],
            })
          : message.completion || message.message;
      return {
        content: role === "user" ? message.message : assistantContent,
        role,
      };
    })
    .filter(Boolean);

  const trimmedEphemeral =
    typeof ephemeralUserTurn === "string" ? ephemeralUserTurn.trim() : "";
  if (trimmedEphemeral) {
    messagesFormatted = [
      ...messagesFormatted,
      { role: "user", content: trimmedEphemeral },
    ];
  }

  return messagesFormatted;
};
